var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg72(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 27,
    viewBox: "0 0 15 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75334 26.2379V14.4771H0.776611V9.89374H4.75334V6.51362C4.75334 2.59101 7.16064 0.455078 10.6767 0.455078C12.3609 0.455078 13.8084 0.579873 14.2302 0.635652V4.73501L11.7917 4.73611C9.87944 4.73611 9.50919 5.64042 9.50919 6.96745V9.89374H14.0696L13.4759 14.4771H9.50919V26.2379H4.75334Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg72);
export default __webpack_public_path__ + "static/media/svg72.9be16b71ec0baf00d6ae76a803abbea0.svg";
export { ForwardRef as ReactComponent };